module.exports = __webpack_public_path__ + "img/5.18995d54.png";